import React from "react";
import { NavLink } from "react-router-dom";
import { CgProfile } from "react-icons/cg";
import { GiShoppingCart } from "react-icons/gi";
import { HiDocumentReport } from "react-icons/hi";
import {
  MdExpandLess,
  MdExpandMore,
  MdLocalMall,
  MdFolder,
  MdPhotoLibrary,
  // MdDashboard,
  MdMessage,
  MdNotificationsNone,
  MdPeopleOutline,
  MdPayment,
  MdPeople,
  MdHistory,
} from "react-icons/md";
import {
  RiProductHuntLine,
  RiShoppingBasketLine,
  RiShoppingBag3Line,
  RiAdminLine,
  RiFootballLine,
  RiExternalLinkLine,
} from "react-icons/ri";
import {
  Nav,
  Navbar,
  NavItem,
  NavLink as BSNavLink,
  Collapse,
  Button,
} from "reactstrap";
import { GiPrayerBeads } from "react-icons/gi";
import {
  FaVideo,
  FaPrayingHands,
  FaImage,
  FaUpload,
  FaUserCircle,
  FaWpforms,
  FaRegNewspaper,
  FaStripeS,
} from "react-icons/fa";
import { GoCalendar } from "react-icons/go";
import { AiOutlineMail } from "react-icons/ai";

import bn from "../../utils/bemnames";
import zocialLogo from "../../assets/img/logo/logo.png";
import istiqlalLogo from "../../assets/img/logo/istiqlal_white.png";
import SportsWyseLogo from "../../assets/img/logo/SportsWyse_white@3x.png";
import sidebarBgImage from "../../assets/img/sidebar/sidebar-4.jpg";

import * as GeneralFunctions from "../../GeneralFunctions";

const sidebarBackground = {
  backgroundImage: `url("${sidebarBgImage}")`,
  backgroundSize: "cover",
  backgroundRepeat: "no-repeat",
};

const navItems = [
  // {
  //   to: "/shopdashboard",
  //   name: "Dashboard",
  //   exact: true,
  //   Icon: MdDashboard,
  //   permission: "shop",
  // },
  {
    to: "/products",
    name: "Products",
    exact: true,
    Icon: RiProductHuntLine,
    permission: "shop",
  },
  {
    to: "/orders",
    name: "Orders",
    exact: true,
    Icon: GiShoppingCart,
    permission: "shop",
  },
  //SideBar routes for RushAdmin
  {
    to: "/events",
    name: "Events",
    exact: true,
    Icon: GiShoppingCart,
    permission: "rushAdmin",
  },
  {
    to: "/parentEvents",
    name: "Parent Events",
    exact: true,
    Icon: GiShoppingCart,
    permission: "rushAdmin",
    spievent: true,
  },
  {
    to: "/teams",
    name: "Teams",
    exact: true,
    Icon: RiFootballLine,
    permission: "rushAdmin",
  },
  {
    to: "/players",
    name: "Players",
    exact: true,
    Icon: FaUserCircle,
    permission: "rushAdmin",
  },
  {
    to: "/payForPlayers",
    name: "Pay For Players",
    exact: true,
    Icon: MdPayment,
    permission: "rushAdmin",
  },
  {
    to: "/registrationForm",
    name: "Registration Form",
    exact: true,
    Icon: FaWpforms,
    permission: "rushAdmin",
  },
  {
    to: "/schedule",
    name: "Schedule",
    exact: true,
    Icon: GoCalendar,
    permission: "rushAdmin",
  },
  // {
  //   to: "/news",
  //   name: "News",
  //   exact: true,
  //   Icon: FaRegNewspaper,
  //   permission: "rushAdmin",
  // },
  // {
  //   to: "/message",
  //   name: "Message",
  //   exact: true,
  //   Icon: MdMessage,
  //   permission: "rushAdmin",
  // },
  // {
  //   to: "/links",
  //   name: "Links",
  //   exact: true,
  //   Icon: RiExternalLinkLine,
  //   permission: "rushAdmin",
  // },
  {
    to: "/notification",
    name: "Notification",
    exact: true,
    Icon: MdNotificationsNone,
    permission: "rushAdmin",
  },
  {
    to: "/teamMail",
    name: "Mail",
    exact: true,
    Icon: AiOutlineMail,
    permission: "rushAdmin",
  },
  {
    to: "/parents",
    name: "Parents",
    exact: true,
    Icon: MdPeople,
    permission: "rushAdmin",
  },
  {
    to: "/staff",
    name: "Staff",
    exact: true,
    Icon: MdPeople,
    permission: "rushAdmin",
  },
  {
    to: "/transactionHistory",
    name: "Transaction History",
    exact: true,
    Icon: MdHistory,
    permission: "rushAdmin",
  },
  {
    to: "/report",
    name: "Report",
    exact: true,
    Icon: HiDocumentReport,
    permission: "rushAdmin",
  },
  //SideBar routes for Admin
  // {
  //   to: "/Dashboard",
  //   name: "Dashboard",
  //   exact: true,
  //   Icon: RiProductHuntLine,
  //   permission: "admin",
  //   forApps: [],
  // },
  {
    to: "/mallProducts",
    name: "Mall Products",
    exact: true,
    Icon: RiProductHuntLine,
    permission: "admin",
    forApps: [
      "bpr",
      "zti",
      "own",
      "uin",
      "snr",
      "annur",
      "aspk",
      "jinah",
      "hebat",
      "epson",
      "trandz",
      "orange",
      "ikalisa",
      "jasklik",
      "barbekoe",
      "krasmart",
      "sarinah",
      "sulteng",
      "unhaspay",
      "istiqlal",
      "codacash",
      "dokuplus",
      "viralspot",
      "ikausakti",
      "jawarapay",
      "kentungan",
      "purworejo",
      "rushsoccer",
      "baliTourism",
      "mapanpreneur",
      "majelisrasulullah",
    ],
  },
  {
    to: "/minimartProducts",
    name: "Minimart Products",
    exact: true,
    Icon: RiShoppingBasketLine,
    permission: "admin",
    forApps: [
      "bpr",
      "zti",
      "own",
      "uin",
      "snr",
      "annur",
      "aspk",
      "jinah",
      "hebat",
      "epson",
      "trandz",
      "orange",
      "ikalisa",
      "jasklik",
      "barbekoe",
      "krasmart",
      "sarinah",
      "sulteng",
      "unhaspay",
      "istiqlal",
      "codacash",
      "dokuplus",
      "viralspot",
      "ikausakti",
      "jawarapay",
      "kentungan",
      "purworejo",
      "rushsoccer",
      "baliTourism",
      "mapanpreneur",
      "majelisrasulullah",
    ],
  },
  {
    to: "/mallPageDetails",
    name: "Mall Page Details",
    exact: true,
    Icon: MdLocalMall,
    permission: "admin",
    forApps: [
      "bpr",
      "zti",
      "own",
      "uin",
      "snr",
      "annur",
      "aspk",
      "jinah",
      "hebat",
      "epson",
      "trandz",
      "orange",
      "ikalisa",
      "jasklik",
      "barbekoe",
      "krasmart",
      "sarinah",
      "sulteng",
      "unhaspay",
      "istiqlal",
      "codacash",
      "dokuplus",
      "viralspot",
      "ikausakti",
      "jawarapay",
      "kentungan",
      "purworejo",
      "rushsoccer",
      "baliTourism",
      "mapanpreneur",
      "majelisrasulullah",
    ],
  },
  {
    to: "/mallCategories",
    name: "Mall Categories",
    exact: true,
    Icon: RiShoppingBag3Line,
    permission: "admin",
    forApps: [
      "bpr",
      "zti",
      "own",
      "uin",
      "snr",
      "annur",
      "aspk",
      "jinah",
      "hebat",
      "epson",
      "trandz",
      "orange",
      "ikalisa",
      "jasklik",
      "barbekoe",
      "krasmart",
      "sarinah",
      "sulteng",
      "unhaspay",
      "istiqlal",
      "codacash",
      "dokuplus",
      "viralspot",
      "ikausakti",
      "jawarapay",
      "kentungan",
      "purworejo",
      "rushsoccer",
      "baliTourism",
      "mapanpreneur",
      "majelisrasulullah",
    ],
  },
  {
    to: "/minimartCategories",
    name: "Minimart Categories",
    exact: true,
    Icon: RiShoppingBag3Line,
    permission: "admin",
    forApps: [
      "bpr",
      "zti",
      "own",
      "uin",
      "snr",
      "annur",
      "aspk",
      "jinah",
      "hebat",
      "epson",
      "trandz",
      "orange",
      "ikalisa",
      "jasklik",
      "barbekoe",
      "krasmart",
      "sarinah",
      "sulteng",
      "unhaspay",
      "istiqlal",
      "codacash",
      "dokuplus",
      "viralspot",
      "ikausakti",
      "jawarapay",
      "kentungan",
      "purworejo",
      "rushsoccer",
      "baliTourism",
      "mapanpreneur",
      "majelisrasulullah",
    ],
  },
  {
    to: "/mallSubCategories",
    name: "Mall SubCategories",
    exact: true,
    Icon: MdFolder,
    permission: "admin",
    forApps: [
      "bpr",
      "zti",
      "own",
      "uin",
      "snr",
      "annur",
      "aspk",
      "jinah",
      "hebat",
      "epson",
      "trandz",
      "orange",
      "ikalisa",
      "jasklik",
      "barbekoe",
      "krasmart",
      "sarinah",
      "sulteng",
      "unhaspay",
      "istiqlal",
      "codacash",
      "dokuplus",
      "viralspot",
      "ikausakti",
      "jawarapay",
      "kentungan",
      "purworejo",
      "rushsoccer",
      "baliTourism",
      "mapanpreneur",
      "majelisrasulullah",
    ],
  },
  {
    to: "/minimartSubCategories",
    name: "Minimart SubCategories",
    exact: true,
    Icon: MdFolder,
    permission: "admin",
    forApps: [
      "bpr",
      "zti",
      "own",
      "uin",
      "snr",
      "annur",
      "aspk",
      "jinah",
      "hebat",
      "epson",
      "trandz",
      "orange",
      "ikalisa",
      "jasklik",
      "barbekoe",
      "krasmart",
      "sarinah",
      "sulteng",
      "unhaspay",
      "istiqlal",
      "codacash",
      "dokuplus",
      "viralspot",
      "ikausakti",
      "jawarapay",
      "kentungan",
      "purworejo",
      "rushsoccer",
      "baliTourism",
      "mapanpreneur",
      "majelisrasulullah",
    ],
  },
  {
    to: "/video",
    name: "Videos",
    exact: true,
    Icon: FaVideo,
    permission: "admin",
    forApps: [
      "bpr",
      "zti",
      "own",
      "uin",
      "snr",
      "annur",
      "aspk",
      "jinah",
      "hebat",
      "epson",
      "trandz",
      "orange",
      "ikalisa",
      "jasklik",
      "barbekoe",
      "krasmart",
      "sarinah",
      "sulteng",
      "unhaspay",
      "istiqlal",
      "codacash",
      "dokuplus",
      "viralspot",
      "ikausakti",
      "jawarapay",
      "kentungan",
      "purworejo",
      "rushsoccer",
      "baliTourism",
      "mapanpreneur",
      "majelisrasulullah",
    ],
  },
  {
    to: "/prayerPageIcons",
    name: "Prayer Page Icons",
    exact: true,
    Icon: FaPrayingHands,
    permission: "admin",
    forApps: [
      "bpr",
      "zti",
      "own",
      "uin",
      "snr",
      "annur",
      "aspk",
      "jinah",
      "hebat",
      "epson",
      "trandz",
      "orange",
      "ikalisa",
      "jasklik",
      "barbekoe",
      "krasmart",
      "sarinah",
      "sulteng",
      "unhaspay",
      "istiqlal",
      "codacash",
      "dokuplus",
      "viralspot",
      "ikausakti",
      "jawarapay",
      "kentungan",
      "purworejo",
      "rushsoccer",
      "baliTourism",
      "mapanpreneur",
      "majelisrasulullah",
    ],
  },
  {
    to: "/prayerPageBanners",
    name: "Prayer Page Banners",
    exact: true,
    Icon: FaImage,
    permission: "admin",
    forApps: [
      "bpr",
      "zti",
      "own",
      "uin",
      "snr",
      "annur",
      "aspk",
      "jinah",
      "hebat",
      "epson",
      "trandz",
      "orange",
      "ikalisa",
      "jasklik",
      "barbekoe",
      "krasmart",
      "sarinah",
      "sulteng",
      "unhaspay",
      "istiqlal",
      "codacash",
      "dokuplus",
      "viralspot",
      "ikausakti",
      "jawarapay",
      "kentungan",
      "purworejo",
      "rushsoccer",
      "baliTourism",
      "mapanpreneur",
      "majelisrasulullah",
    ],
  },
  {
    to: "/prayerTimeBanners",
    name: "Prayer Time Banners",
    exact: true,
    Icon: GiPrayerBeads,
    permission: "admin",
    forApps: [
      "bpr",
      "zti",
      "own",
      "uin",
      "snr",
      "annur",
      "aspk",
      "jinah",
      "hebat",
      "epson",
      "trandz",
      "orange",
      "ikalisa",
      "jasklik",
      "barbekoe",
      "krasmart",
      "sarinah",
      "sulteng",
      "unhaspay",
      "istiqlal",
      "codacash",
      "dokuplus",
      "viralspot",
      "ikausakti",
      "jawarapay",
      "kentungan",
      "purworejo",
      "rushsoccer",
      "baliTourism",
      "mapanpreneur",
      "majelisrasulullah",
    ],
  },
  {
    to: "/studentFile",
    name: "Upload Student File",
    exact: true,
    Icon: FaUpload,
    permission: "admin",
    forApps: ["uin"],
  },
  {
    to: "/epipath",
    name: "Epipath",
    exact: true,
    Icon: MdPeopleOutline,
    permission: "admin",
    forApps: ["istiqlal"],
  },
  {
    to: "/hadist",
    name: "Hadist",
    exact: true,
    Icon: MdNotificationsNone,
    permission: "admin",
    forApps: ["istiqlal"],
  },
  {
    to: "/duafeeds",
    name: "Dua Feeds",
    exact: true,
    Icon: MdPhotoLibrary,
    permission: "admin",
    forApps: ["trandz"],
  },
  //SideBar routes for super Admin
  {
    to: "/adminList",
    name: "Admin List",
    exact: true,
    Icon: RiAdminLine,
    permission: "superadmin",
  },
  {
    to: "/feeds",
    name: "All Feeds",
    exact: true,
    Icon: MdPhotoLibrary,
    permission: "superadmin",
  },
  // SideBar routes for jasklikadmin
  {
    to: "/insurance",
    name: "Insurance Purchase",
    exact: true,
    Icon: FaRegNewspaper,
    permission: "jasklikadmin",
  },
  {
    to: "/claims",
    name: "Insurance Claim",
    exact: true,
    Icon: FaRegNewspaper,
    permission: "jasklikadmin",
  },

  //sidebar for rushuser
  {
    to: "/parentlist",
    name: "Adults List",
    exact: true,
    Icon: MdPeople,
    permission: "rushUser",
  },
  {
    to: "/events",
    name: "Events",
    exact: true,
    Icon: GiShoppingCart,
    permission: "rushUser",
  },
  {
    to: "/memberships",
    name: "Memberships",
    exact: true,
    Icon: RiShoppingBag3Line,
    permission: "membershipAdmin",
  },
  {
    to: "/profile",
    name: "Profile",
    exact: true,
    Icon: CgProfile,
    permission: "membershipAdmin",
  }
];

const bem = bn.create("sidebar");

class Sidebar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpenComponents: true,
      isOpenContents: true,
      isOpenPages: true,
      collapsed: false,
    };
  }

  handleClick = (name) => () => {
    this.setState((prevState) => {
      const isOpen = prevState[`isOpen${name}`];

      return {
        [`isOpen${name}`]: !isOpen,
      };
    });
  };

  render() {
    const user = GeneralFunctions.getAuthUser();
    const userPermission = GeneralFunctions.getPermissions();
    let forApp = user.forApp || user.loggedInApp;
    let logo =
      userPermission === "admin"
        ? forApp === "istiqlal"
          ? istiqlalLogo
          : zocialLogo
        : userPermission === "rushAdmin"
          ? SportsWyseLogo
          : zocialLogo;

    let height =
      forApp === "istiqlal" && userPermission !== "shop"
        ? "100"
        : userPermission === "rushAdmin"
          ? "65"
          : "45";

    let width =
      forApp === "istiqlal" && userPermission !== "shop"
        ? "170"
        : userPermission === "rushAdmin"
          ? "190"
          : "160";
    return (
      <aside className={bem.b()}>
        <div className={bem.e("background")} style={sidebarBackground} />
        <div
          className={bem.e("content")}
          style={{ backgroundColor: "#17517B" }}
        >
          <Navbar>
            <BSNavLink
              tag={NavLink}
              to={"/"}
              exact={true}
              style={{ padding: 0, margin: "auto" }}
            >
              <img
                src={logo}
                width={width}
                height={height}
                className="pr-2"
                alt=""
              />
              {forApp === "istiqlal" && userPermission !== "shop" ? (
                <small className="text-white  ml-4">powered by Zocial</small>
              ) : (
                ""
              )}
            </BSNavLink>
          </Navbar>
          <Nav vertical>
            {navItems
              .filter((navItem) =>
                navItem.forApps
                  ? navItem.forApps.includes(forApp)
                  : user.connectedUser && !user.connectedUser.SPIEvent
                    ? !navItem.hasOwnProperty("spievent")
                    : navItem.hasOwnProperty("spievent")
                      ? navItem.spievent
                      : navItem
              )
              .map(
                (
                  { to, name, exact, Icon, permission, forApps, submenu },
                  index
                ) =>
                  permission === userPermission && (
                    <NavItem key={index} className={bem.e("nav-item")}>
                      {to && (
                        <BSNavLink
                          id={`navItem-${name}-${index}`}
                          tag={NavLink}
                          to={to}
                          activeClassName="active"
                          exact={exact}
                        >
                          <Icon className={bem.e("nav-item-icon")} />
                          <span className="">{name}</span>
                        </BSNavLink>
                      )}
                      {!to && (
                        <React.Fragment>
                          <Button
                            className="nav-link"
                            style={{ cursor: "pointer" }}
                            id={`navItem-${name}-${index}`}
                            onClick={(event) =>
                              this.setState({
                                collapsed: !this.state.collapsed,
                              })
                            }
                          >
                            <Icon className={bem.e("nav-item-icon")} />
                            <span className="" style={{ width: "100%" }}>
                              {name}
                            </span>
                            {this.state.collapsed ? (
                              <MdExpandLess
                                style={{ height: 30, width: 30 }}
                                className={bem.e("nav-item-icon")}
                              ></MdExpandLess>
                            ) : (
                              <MdExpandMore
                                style={{ height: 30, width: 30 }}
                                className={bem.e("nav-item-icon")}
                              ></MdExpandMore>
                            )}
                          </Button>
                          <Collapse
                            isOpen={this.state.collapsed}
                            navbar
                            style={{ marginLeft: 30 }}
                          >
                            <Nav navbar>
                              {submenu.map(({ to, name, exact }, index) => (
                                <BSNavLink
                                  key={index}
                                  id={`navItem-${name}-${index}`}
                                  tag={NavLink}
                                  to={to}
                                  activeClassName="active"
                                  exact={exact}
                                >
                                  <span
                                    className=""
                                    style={{ paddingLeft: 10 }}
                                  >
                                    {name}
                                  </span>
                                </BSNavLink>
                              ))}
                            </Nav>
                          </Collapse>
                        </React.Fragment>
                      )}
                    </NavItem>
                  )
              )}
            {user.role === "rushAdmin" && (
              <NavItem className={bem.e("nav-item")}>
                <BSNavLink
                  id="stripeDetails"
                  activeClassName="active"
                  target="_blank"
                  href={user.connectedUser && user.connectedUser.loginLink}
                >
                  <FaStripeS className={bem.e("nav-item-icon")} />
                  <span className="">Stripe Details</span>
                </BSNavLink>
              </NavItem>
            )}
          </Nav>
        </div>
      </aside>
    );
  }
}

export default Sidebar;
